export function LumieBg({ className = "" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
      className={className}
    >
      <defs>
        <linearGradient id="lumie-bg-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fffbeb" />
          <stop offset="100%" stopColor="#fef3c7" />
        </linearGradient>
        <linearGradient id="lumie-bg-gradient-dark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1a1208" />
          <stop offset="100%" stopColor="#292018" />
        </linearGradient>

        <style>
          {`
            .lumie-bg {
              fill: url(#lumie-bg-gradient);
            }
            .dark .lumie-bg {
              fill: url(#lumie-bg-gradient-dark);
            }

            .lumie-blob {
              fill: #f59e0b;
              opacity: 0.15;
              transform-origin: center;
              animation: lumie-breathe 8s ease-in-out infinite alternate;
              filter: blur(80px);
            }
            
            .dark .lumie-blob {
              fill: #fbbf24;
              opacity: 0.1;
            }

            @keyframes lumie-breathe {
              0% { transform: scale(0.9); opacity: 0.1; }
              100% { transform: scale(1.1); opacity: 0.25; }
            }

            @keyframes lumie-drift-1 {
              0% { transform: translate(0, 0); }
              50% { transform: translate(100px, 50px); }
              100% { transform: translate(0, 0); }
            }
            
            @keyframes lumie-drift-2 {
              0% { transform: translate(0, 0); }
              50% { transform: translate(-80px, 80px); }
              100% { transform: translate(0, 0); }
            }
          `}
        </style>
      </defs>

      <rect width="1920" height="1080" className="lumie-bg" />

      {/* Blob layers with multiple animations (breathing + drifting) */}
      <g style={{ animation: "lumie-drift-1 25s ease-in-out infinite" }}>
        <circle cx="400" cy="300" r="300" className="lumie-blob" style={{ animationDelay: "0s", animationDuration: "9s" }} />
      </g>
      
      <g style={{ animation: "lumie-drift-2 30s ease-in-out infinite" }}>
        <circle cx="1500" cy="800" r="400" className="lumie-blob" style={{ animationDelay: "-3s", animationDuration: "11s" }} />
      </g>
      
      <g style={{ animation: "lumie-drift-1 35s ease-in-out infinite reverse" }}>
        <circle cx="1200" cy="200" r="250" className="lumie-blob" style={{ animationDelay: "-6s", animationDuration: "10s", fill: "#fbbf24" }} />
      </g>
      
      <g style={{ animation: "lumie-drift-2 28s ease-in-out infinite reverse" }}>
        <circle cx="600" cy="900" r="350" className="lumie-blob" style={{ animationDelay: "-1s", animationDuration: "12s", fill: "#fcd34d" }} />
      </g>

      <g style={{ animation: "lumie-drift-1 40s ease-in-out infinite" }}>
        <circle cx="960" cy="540" r="500" className="lumie-blob" style={{ animationDelay: "-4s", animationDuration: "14s", opacity: "0.1" }} />
      </g>
    </svg>
  );
}
